var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.gallery)?_c('div',{key:"app-gallery"},[_c('Gallery')],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }